import styled from '@emotion/styled'
import { ButtonsBlock, LPTd, MessageTimelineTableRow } from './styled'
import { Spinner, Tooltip } from '@chakra-ui/react'
import { memo, useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

export enum SplitterValues {
    Up = 'up',
    UpFirst = 'upFirst',
    DownLast = 'downLast',
    Down = 'down',
    UpDown = 'updown'
}

export enum DividerPlacement {
    Before = 'before',
    After = 'after'
}

const ChevronDown = () => <FiChevronDown size={8} strokeWidth={3} color='white'/>
const ChevronUp = () => <FiChevronUp size={8} strokeWidth={3} color='white'/>

const SplitterRow = styled(MessageTimelineTableRow)`
    ${({ direction }) =>
        direction === SplitterValues.UpDown
            ? `
        position: relative;
        & > td {
            background-color: var(--chakra-colors-splitter);
            height: 2px;
            padding-bottom: 0;
            padding-top: 0;
            top: -10px;
        }
  `
            : `
        position: relative;
        & > td {
            background-color: var(--chakra-colors-splitter);
            height: 2px;
            padding-bottom: 0;
            padding-top: 0;
            min-height: 13px;
            top: ${direction === SplitterValues.Up ? '0px' : '-10px'};
        }

        ${
            direction === SplitterValues.Down &&
            `
            & > td > div {
                margin-top: 0px !important;
            }
        `
        }
  `}
`

const DividerLine = styled.div`
    height: 2px;
    background-color: transparent;
    width: 100%;
`

const SplitterWithIcon = styled.div`
    border: 1px solid var(--chakra-colors-splitter);
    border-radius: 2px;
    background-color: var(--chakra-colors-splitter);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    :hover {
        background-color: ${({ theme }) => 'var(--chakra-colors-gray-600)'};
    }
`

const SplitterButton = ({
    label,
    itemNumber,
    nextItemNumber,
    icon,
    onSplitterClickValue,
    onSplitterClick,
    marginTop,
    marginBottom
}: {
    label: string,
    itemNumber: number,
    nextItemNumber: number,
    icon: any,
    onSplitterClickValue: SplitterValues,
    onSplitterClick: (direction: SplitterValues, itemNumber: number, nextItemNumber: number) => void,
    marginTop?: number,
    marginBottom?: number
}) => {
    const [showSpinner, setShowSpinner] = useState(false)

    return <Tooltip
        openDelay={500}
        label={label}
        placement="right"
    >
        {showSpinner
            ? <Spinner width='8px' height='8px' marginTop={`${marginTop}px`} marginBottom={`${marginBottom}px`}/>
            : <SplitterWithIcon
                onClick={() =>{
                    if (showSpinner)
                        return
                    setShowSpinner(true)
                    onSplitterClick(
                        onSplitterClickValue,
                        itemNumber,
                        nextItemNumber
                    )
                }}
                style={{
                    height: '8px',
                    marginTop: marginTop,
                    marginBottom: marginBottom,
                    cursor: 'pointer'
                }}
            >
                {icon}
            </SplitterWithIcon>
        }
    </Tooltip>
}

export const TableSplitterRow = memo(({
    value,
    emptyCellsAmount,
    itemNumber,
    nextItemNumber,
    onSplitterClick
}: {
    value: string
    emptyCellsAmount: number,
    itemNumber: number,
    nextItemNumber: number,
    onSplitterClick: (direction: SplitterValues, itemNumber: number, nextItemNumber: number) => void
}) => {

    return (
        <SplitterRow direction={value} height="1px" bgColor={'#ffffff77'}>
            <LPTd>
                <div style={{ position: 'relative', maxHeight: '1px' }}>
                    <ButtonsBlock>
                        {(value === SplitterValues.Up || value === SplitterValues.UpDown) && (
                            <SplitterButton
                                label={`Show filtered out messages ${value === SplitterValues.UpDown ? 'before' : 'after'} this message`}
                                itemNumber={itemNumber}
                                nextItemNumber={nextItemNumber}
                                marginTop={value === SplitterValues.UpDown ? 0 : 9}
                                onSplitterClickValue={value === SplitterValues.Up ? SplitterValues.UpFirst : SplitterValues.Up}
                                onSplitterClick={onSplitterClick}
                                icon={value === SplitterValues.UpDown ? <ChevronDown/> : <ChevronUp/>}
                            />
                        )}
                        {value === SplitterValues.UpDown && <DividerLine />}
                        {(value === SplitterValues.Down || value === SplitterValues.UpDown) && (
                            <SplitterButton
                                label={`Show filtered out messages ${value === SplitterValues.UpDown ? 'after' : 'before'} this message`}
                                itemNumber={itemNumber}
                                nextItemNumber={nextItemNumber}
                                marginBottom={value === SplitterValues.UpDown ? 0 : 10}
                                onSplitterClickValue={value === SplitterValues.Down ? SplitterValues.DownLast : SplitterValues.Down}
                                onSplitterClick={onSplitterClick}
                                icon={value === SplitterValues.UpDown ? <ChevronUp /> : <ChevronDown />}
                            />
                        )}
                    </ButtonsBlock>
                </div>
            </LPTd>
            {Array.from({ length: emptyCellsAmount }).map((_, i) => (
                <LPTd key={i} />
            ))}
        </SplitterRow>
    )
})